import styled from "styled-components";
import media from "../../utils/media";
import { ScriptDirection } from "../../api/typedefs/Bible";

interface ContentWrapperProps {
  scriptDirection: ScriptDirection;
}

const ContentWrapper = styled.section<ContentWrapperProps>`
  direction: ${props => props.scriptDirection || "ltr"};
  padding: 0 1rem;
  font-family: "Noto Serif";
  color: ${props => props.theme.primaryText};
  ${media.desktop` padding: 0 6rem; `};
`;

export default ContentWrapper;
